import React from 'react';
import Page from '../../components/Page';
import { useQuery } from 'react-fetching-library';
import { Card, CardContent, Tabs, Tab } from '@mui/material';
import NotificationSettings from '../../sections/employee/notification/NotificationSettings';

import { getNotificationSettingsAction } from '../../services/request';

const Notification = () => {
  const { loading, payload, error } = useQuery(getNotificationSettingsAction());
  const [currentTab, setCurrentTab] = React.useState(0);
  const [notificationSettings, setNotificationSettings] = React.useState([]);

  React.useEffect(() => {
    if (!error && !loading) {
      setNotificationSettings(payload.results);
    }
  }, [loading]);

  return (
    <Page title="Powiadomienia">
      <Card>
        <CardContent>
          <Tabs variant="scrollable" scrollButtons="auto" value={currentTab} onChange={(e, value) => setCurrentTab(value)}>
            {notificationSettings.map(element => <Tab key={element.id} label={element.pl_type_name} />)}
          </Tabs>

          {notificationSettings.map((element, index) => (<React.Fragment key={element.id}>
            {currentTab === index ? <NotificationSettings {...element} setNotificationSettings={setNotificationSettings}/> : null}
          </React.Fragment>))}

        </CardContent>
      </Card>
    </Page>
  );
};


export default Notification;
